import { Row, Column } from '@simplywallst/ui-core';
import ChevronRightSmallSolid from '@simplywallst/ui-core/icons/ChevronRightSmallSolid';
import DiscoverSolid from '@simplywallst/ui-core/icons/DiscoverSolid';
import {
  Wrapper,
  EducationalVideoTitle,
  EducationalVideoContent,
  VideoLink,
  Tip,
  Image,
} from './styled';
import { useTheme } from '@simplywallst/ui-core';
import { getStaticUrl, useCloudflareImage } from '@/hooks/useCloudflareImage';

interface Props {
  title: string;
  content: string;
  link: string;
}

export const EducationalContent = ({ title, content, link }: Props) => {
  const theme = useTheme();
  const videoImg = useCloudflareImage({
    src: getStaticUrl('dashboard/youTube-thumbnail.png'),
    width: 80,
    height: 50,
    fit: 'cover',
  });
  return (
    <Wrapper>
      <Row gap={`${theme.x1spacePx}px`} alignItem="center">
        <DiscoverSolid fill={theme.color.chart04} />
        <Tip>Quick Tip</Tip>
      </Row>
      <EducationalVideoTitle>How to react to {title}</EducationalVideoTitle>
      <EducationalVideoContent>{content}</EducationalVideoContent>
      <Row
        as="a"
        href={link}
        target="_blank"
        rel="noreferrer"
        alignItem="center"
      >
        <Column displayFlex col={4} colMd={2}>
          <Image alt={title} src={videoImg} />
        </Column>
        <Column displayFlex col={7} colMd={6}>
          <VideoLink>Watch the short video on YouTube to learn more</VideoLink>
        </Column>
        <Column displayFlex col={1} colMd={4}>
          <ChevronRightSmallSolid fill={theme.color.brand01} />
        </Column>
      </Row>
    </Wrapper>
  );
};
